// src/components/Venue.js
import React from 'react';

const Venue = () => {
  return (
    <section id="venue" className="venue-section">
      <div className="container">
        <div className="section-header fade-in">
          <h2><i className="fas fa-map-marker-alt me-2"></i>Venue</h2>
        </div>
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="venue-card fade-in text-center">
              <i className="fas fa-building venue-icon"></i>
              <h3>Jacaranda Hall, India Habitat Centre</h3>
              <div className="venue-details">
                <p><i className="fas fa-calendar-alt me-2"></i><strong>Dates:</strong> 8th & 9th October, 2025</p>
                <div className="row">
                  <div className="col-lg-6 text-lg-end">
                    <p className='mb-0'><i className="fas fa-map-pin me-2"></i>  New Delhi, India</p>
                  </div>
                  <div className="col-lg-6 text-lg-start">
                    <p className='small mb-0'>
                    <a href="https://maps.app.goo.gl/rGQdUKCCUfDkutJ99" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link me-2"></i> Location on Map
                    </a>
                    </p>
                  </div>
                </div>
                {/* <p className='mb-0'><i className="fas fa-clock me-2"></i><strong>Duration:</strong> 2 Days</p> */}
                {/* <p className="mt-3">The India Habitat Centre is a premier venue in the heart of New Delhi, providing state-of-the-art facilities for academic conferences and networking events.</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Venue;